var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-main',{class:this.$route.path.includes('login') ||
   this.$route.path.includes('register') ||
   this.$route.path.includes('verify') || 
   this.$route.path.includes('change-pass')|| 
   this.$route.path.includes('set-pass')
   ? '' : 'background-gray',staticStyle:{"padding-bottom":"0"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }